import React, { useState, useEffect } from 'react';
import { FaTimes, FaExpand, FaCompress } from 'react-icons/fa';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

import Select from "react-select";

const API_URL = '/api';

const initialHeader = {
  rfq_no: '',
  rfq_date: '',
  pr_no: '',
  vendor_code: '',
  vendor_name: '',
  status: 'Open',
  delivery_terms: '',
  payment_terms: '',
  remark: '', // ✅ changed from 'remarks',
  valid_upto: '' 
};


const initialItem = {
  item_code: '', description: '', quantity: '', unit_price: '', unit_of_measure: '', amount: '', discount_percent: '', discount: '', net_amount: '', status: '',   valid_upto: ''   // ✅ NEW

};

const RFQItemsFormModal = ({ open, onClose, onSubmit, initialData, isEdit }) => {
  const [header, setHeader] = useState(initialHeader);
  const [items, setItems] = useState([{ ...initialItem }]);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  const [isMaximized, setIsMaximized] = useState(false);
const [expandedRemarks, setExpandedRemarks] = useState({});
const [remarkOverflow, setRemarkOverflow] = useState({});
const [activeCell, setActiveCell] = useState(null);
  const [deliveryTerms, setDeliveryTerms] = useState([]);
  const [paymentTerms, setPaymentTerms] = useState([]);
const [columnWidths, setColumnWidths] = useState({
  item_code: 140,
  description: 320,
  quantity: 100,
  unit_of_measure: 120,
  unit_price: 120,
  amount: 120,
  discount_percent: 110,
  discount: 120,
  net_amount: 140,
  status: 120,
  remarks: 320,
  valid_upto: 150
});

const [resizing, setResizing] = useState(null);
const handleHeaderChange = (e) => {
  const { name, value } = e.target;

  setHeader(prev => ({
    ...prev,
    [name]: value
  }));

  // auto apply valid upto to items
  if (name === "valid_upto") {
    setItems(prev =>
      prev.map(item => ({
        ...item,
        valid_upto: value
      }))
    );
  }
};

const startResize = (column, e) => {
  e.preventDefault();

  setResizing({
    column,
    startX: e.clientX,
    startWidth: columnWidths[column]
  });
};

const handleMouseMove = (e) => {
  if (!resizing) return;

  const diff = e.clientX - resizing.startX;

  setColumnWidths(prev => ({
    ...prev,
    [resizing.column]: Math.max(60, resizing.startWidth + diff)
  }));
};

const stopResize = () => {
  setResizing(null);
};

useEffect(() => {
  window.addEventListener("mousemove", handleMouseMove);
  window.addEventListener("mouseup", stopResize);

  return () => {
    window.removeEventListener("mousemove", handleMouseMove);
    window.removeEventListener("mouseup", stopResize);
  };
}, [resizing]);
  useEffect(() => {
    if (!open) return;

    if (isEdit && initialData) {
      const formattedDate = initialData.rfq_date?.split("T")[0] || '';
setHeader({
  ...initialHeader,
  ...initialData,
  rfq_date: formattedDate,
  delivery_terms: initialData.delivery_terms || "",
  payment_terms: initialData.payment_terms || ""
});
      setItems(initialData.items?.length ? initialData.items : [{ ...initialItem }]);
    } else {
      setHeader(initialHeader);
      setItems([{ ...initialItem }]);
    }
    setErrors({});

    // Fetch delivery & payment terms
    const fetchTerms = async () => {
      try {
        const [delRes, payRes] = await Promise.all([
          fetch(`${API_URL}/delivery-terms`),
          fetch(`${API_URL}/payment-terms`)
        ]);
        const [delData, payData] = await Promise.all([delRes.json(), payRes.json()]);
        setDeliveryTerms(delData || []);
        setPaymentTerms(payData || []);
      } catch (err) {
        console.error("Error fetching terms:", err);
      }
    };
    fetchTerms();

  }, [open, initialData, isEdit]);
const toggleRemark = (idx) => {
  setExpandedRemarks(prev => ({
    ...prev,
    [idx]: !prev[idx]
  }));
};
const remarkRefs = React.useRef({});

const checkOverflow = (idx) => {
  const el = remarkRefs.current[idx];
  if (!el) return;

  const isOverflowing = el.scrollHeight > el.clientHeight + 1;

  setRemarkOverflow(prev => ({
    ...prev,
    [idx]: isOverflowing
  }));
};
useEffect(() => {
  const newOverflow = {};

  items.forEach((_, idx) => {
    const el = remarkRefs.current[idx];
    if (!el) return;

    newOverflow[idx] = el.scrollHeight > el.clientHeight + 1;
  });

  setRemarkOverflow(prev => {
    // avoid unnecessary state updates
    for (const key in newOverflow) {
      if (prev[key] !== newOverflow[key]) {
        return newOverflow;
      }
    }
    return prev;
  });
}, [items, expandedRemarks]);

  const handleItemChange = (idx, e) => {
    const newItems = [...items];
    newItems[idx][e.target.name] = e.target.value;

    const q = parseFloat(newItems[idx].quantity) || 0;
    const up = parseFloat(newItems[idx].unit_price) || 0;
    const amt = q * up;

    const discP = parseFloat(newItems[idx].discount_percent) || 0;
    const disc = amt * (discP / 100);

    newItems[idx].amount = amt.toFixed(2);
    newItems[idx].discount = disc.toFixed(2);
    newItems[idx].net_amount = (amt - disc).toFixed(2);

    setItems(newItems);
  };

  const validate = () => {
    const errs = {};
    if (!header.rfq_no?.trim()) errs.rfq_no = 'Required';
    if (!header.rfq_date) errs.rfq_date = 'Required';
    if (!header.vendor_code?.trim()) errs.vendor_code = 'Required';
    if (!header.vendor_name?.trim()) errs.vendor_name = 'Required';
    items.forEach((item, idx) => {
      if (!item.item_code) errs[`item_code_${idx}`] = 'Required';
      if (!item.description) errs[`description_${idx}`] = 'Required';
      if (!item.quantity) errs[`quantity_${idx}`] = 'Required';
      if (!item.unit_price) errs[`unit_price_${idx}`] = 'Required';
      if (!item.unit_of_measure) errs[`unit_of_measure_${idx}`] = 'Required';
    });
    setErrors(errs);
    return !Object.keys(errs).length;
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (!validate() || isSubmitting) return;

    setIsSubmitting(true);
    setLoading(true);

    try {
      const rfqId = initialData?.id;
      const headerPayload = {
        rfq_no: header.rfq_no.trim(),
        rfq_date: header.rfq_date || null,
        pr_no: header.pr_no.trim(),
        vendor_code: header.vendor_code.trim(),
        vendor_name: header.vendor_name.trim(),
        status: header.status,
         valid_upto: header.valid_upto || null, 
delivery_terms: header.delivery_terms?.trim() || "",
payment_terms: header.payment_terms?.trim() || "",

        remark: header.remark?.trim() || "",  // ✅ Safe handling here
        updated_at: new Date()
      };


      const headerRes = await fetch(`${API_URL}/rfqs/${rfqId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(headerPayload)
      });

      if (!headerRes.ok) {
        const errData = await headerRes.json();
        throw new Error(errData.message || 'Failed to update RFQ header');
      }

      const itemsRes = await fetch(`${API_URL}/rfqs/${rfqId}/items`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });

      if (!itemsRes.ok) {
        const errData = await itemsRes.json();
        throw new Error(errData.message || 'Failed to update RFQ items');
      }

      onSubmit?.();
      setSuccessMessage("✅ RFQ successfully updated!");
      setTimeout(() => setSuccessMessage(null), 3000);

    } catch (err) {
      alert(err.message || 'Error saving RFQ');
    } finally {
      setIsSubmitting(false);
      setLoading(false);
    }
  };

  if (!open) return null;

  return (
    <div
      className={`fixed inset-0 z-50 bg-black bg-opacity-40
    ${isMaximized ? '' : 'flex items-center justify-center p-4'}
  `}
    >

      {loading && (
        <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}

      {successMessage && (
        <div className="absolute top-4 right-4 bg-green-600 text-white px-4 py-2 rounded shadow-lg z-50">
          {successMessage}
        </div>
      )}

      <div
        className={`bg-[#E5E1DA] shadow-2xl relative overflow-y-auto transition-all duration-300
    ${isMaximized
            ? 'w-screen h-screen max-w-none max-h-none rounded-none'
            : 'w-full max-w-4xl max-h-[95vh] rounded-2xl'
          }
    p-4 sm:p-8
  `}
      >


        <div className="absolute top-4 right-4 flex gap-2">
          {/* Maximize / Minimize */}
          <button
            className="text-[#2b6777] hover:text-[#52ab98]"
            onClick={() => setIsMaximized(prev => !prev)}
            title={isMaximized ? 'Minimize' : 'Maximize'}
          >
            {isMaximized ? <FaCompress size={16} /> : <FaExpand size={16} />}
          </button>

          {/* Close */}
          <button
            className="text-[#2b6777] hover:text-red-500"
            onClick={onClose}
            title="Close"
          >
            <FaTimes size={18} />
          </button>
        </div>


        <h2 className="text-xl sm:text-2xl font-bold text-[#2b6777] mb-4 sm:mb-6 text-center">
          {isEdit ? 'Edit RFQ' : 'Create RFQ'}
        </h2>

        <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-6">
          {/* RFQ Header Section */}
          <div className="bg-white p-3 sm:p-4 rounded-xl shadow-md">
            <h3 className="text-base sm:text-lg font-bold text-[#2b6777] mb-2">RFQ Information</h3>

            <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 sm:gap-4">
              {/* Render RFQ inputs dynamically */}
              {[
                { label: "RFQ No", name: "rfq_no", readOnly: true },
                { label: "RFQ Date", name: "rfq_date", type: "date", readOnly: true },
                { label: "PR No", name: "pr_no", readOnly: true },
                { label: "Vendor Code", name: "vendor_code", readOnly: true },
                { label: "Vendor Name", name: "vendor_name", readOnly: true },
              ].map((field, i) => (
                <div key={i} className="flex flex-col sm:flex-row sm:gap-2 sm:items-center">
                  <label className="block text-sm font-medium text-[#2b6777] mb-1 sm:mb-0 sm:w-1/4 text-center sm:text-left">
                    {field.label} *
                  </label>
                  <div className="w-full sm:w-3/4">
                    <input
                      type={field.type || "text"}
                      name={field.name}
                      value={header[field.name]}
                      readOnly={field.readOnly}
                      className={`w-full border rounded px-3 py-2 ${field.readOnly ? 'bg-gray-100' : ''} ${errors[field.name] ? 'border-red-400' : 'border-[#c8d8e4]'}`}
                    />
                    {errors[field.name] && <span className="text-xs text-red-500 mt-1 block">{errors[field.name]}</span>}
                  </div>
                </div>
              ))}

              {/* Status */}
              <div className="flex flex-col sm:flex-row sm:gap-2 sm:items-center">
                <label className="block text-sm font-medium text-[#2b6777] mb-1 sm:mb-0 sm:w-1/4 text-center sm:text-left">Status</label>
                <div className="w-full sm:w-3/4">
                  <select
                    name="status"
                    value={header.status}
                    disabled
                    className="w-full border rounded px-3 py-2 border-[#c8d8e4] bg-gray-100"
                  >
                    <option value="Open">Open</option>
                    <option value="Negotiation">Negotiate</option>
                    <option value="Bid Closed">Bid closed</option>
                    <option value="Win">Win</option>
                    <option value="Lost">Lost</option>
                  </select>
                </div>
              </div>

         

              {/* Remarks */}
              {/* Remark field */}
              <div className="flex flex-col sm:flex-row sm:gap-2 sm:items-start">
                <label className="block text-sm font-medium text-[#2b6777] mb-1 sm:mb-0 sm:w-1/4 text-center sm:text-left">Remark</label>
                <div className="w-full sm:w-3/4">
                  <textarea
                    name="remark"
                    value={header.remark}
                    onChange={e => setHeader({ ...header, remark: e.target.value })}
                    className="w-full border rounded px-3 py-2 border-[#c8d8e4] focus:border-[#52ab98] focus:ring-[#52ab98] min-h-[80px]"
                    placeholder="Enter remark for this RFQ..."
                  />
                </div>
              </div>
              {/* Valid Upto */}
<div className="flex flex-col sm:flex-row sm:gap-2 sm:items-center">
  <label className="block text-sm font-medium text-[#2b6777] mb-1 sm:mb-0 sm:w-1/4">
    Valid Upto
  </label>

  <div className="w-full sm:w-3/4">
    <input
      type="date"
      name="valid_upto"
      value={header.valid_upto}
      onChange={handleHeaderChange}
      className="w-full border rounded px-3 py-2 border-[#c8d8e4]"
    />
  </div>
</div>


            </div>
          </div>

          {/* RFQ Items Section */}
          <div className="bg-white p-3 sm:p-4 rounded-xl shadow-md">
            <h3 className="text-base sm:text-lg font-bold text-[#2b6777] mb-2">RFQ Items</h3>
            <div className="overflow-x-auto max-h-[55vh]">

              <table className="min-w-full border border-[#c8d8e4] table-fixed border-collapse">
                <thead>
  <tr className="bg-[#c8d8e4] text-[#2b6777]">

    <th className="p-1 sm:p-2 w-12">#</th>

    <th className="p-1 sm:p-2 relative border-r border-[#b6c7d6]" style={{ width: columnWidths.item_code }}>
      Item Code
      <div
        onMouseDown={(e) => startResize("item_code", e)}
        className="absolute top-0 right-0 h-full w-2 cursor-col-resize hover:bg-blue-400 opacity-40"
      />
    </th>

    <th className="p-1 sm:p-2 relative border-r border-[#b6c7d6]" style={{ width: columnWidths.description }}>
      Description
      <div
        onMouseDown={(e) => startResize("description", e)}
        className="absolute top-0 right-0 h-full w-2 cursor-col-resize hover:bg-blue-400 opacity-40"
      />
    </th>

    <th className="p-1 sm:p-2 relative border-r border-[#b6c7d6]" style={{ width: columnWidths.quantity }}>
      Qty
      <div
        onMouseDown={(e) => startResize("quantity", e)}
        className="absolute top-0 right-0 h-full w-2 cursor-col-resize hover:bg-blue-400 opacity-40"
      />
    </th>

    <th className="p-1 sm:p-2 relative border-r border-[#b6c7d6]" style={{ width: columnWidths.unit_of_measure }}>
      UOM
      <div
        onMouseDown={(e) => startResize("unit_of_measure", e)}
        className="absolute top-0 right-0 h-full w-2 cursor-col-resize hover:bg-blue-400 opacity-40"
      />
    </th>

    <th className="p-1 sm:p-2 relative border-r border-[#b6c7d6]" style={{ width: columnWidths.unit_price }}>
      Unit Price
      <div
        onMouseDown={(e) => startResize("unit_price", e)}
        className="absolute top-0 right-0 h-full w-2 cursor-col-resize hover:bg-blue-400 opacity-40"
      />
    </th>

    <th className="p-1 sm:p-2 relative border-r border-[#b6c7d6]" style={{ width: columnWidths.amount }}>
      Amount
      <div
        onMouseDown={(e) => startResize("amount", e)}
        className="absolute top-0 right-0 h-full w-2 cursor-col-resize hover:bg-blue-400 opacity-40"
      />
    </th>

    <th className="p-1 sm:p-2 relative border-r border-[#b6c7d6]" style={{ width: columnWidths.discount_percent }}>
      Disc %
      <div
        onMouseDown={(e) => startResize("discount_percent", e)}
        className="absolute top-0 right-0 h-full w-2 cursor-col-resize hover:bg-blue-400 opacity-40"
      />
    </th>

    <th className="p-1 sm:p-2 relative border-r border-[#b6c7d6]" style={{ width: columnWidths.discount }}>
      Discount
      <div
        onMouseDown={(e) => startResize("discount", e)}
        className="absolute top-0 right-0 h-full w-2 cursor-col-resize hover:bg-blue-400 opacity-40"
      />
    </th>

    <th className="p-1 sm:p-2 relative border-r border-[#b6c7d6]" style={{ width: columnWidths.net_amount }}>
      Net Amount
      <div
        onMouseDown={(e) => startResize("net_amount", e)}
        className="absolute top-0 right-0 h-full w-2 cursor-col-resize hover:bg-blue-400 opacity-40"
      />
    </th>

    <th className="p-1 sm:p-2 relative border-r border-[#b6c7d6]" style={{ width: columnWidths.status }}>
      Status
      <div
        onMouseDown={(e) => startResize("status", e)}
        className="absolute top-0 right-0 h-full w-2 cursor-col-resize hover:bg-blue-400 opacity-40"
      />
    </th>

    <th className="p-1 sm:p-2 relative border-r border-[#b6c7d6]" style={{ width: columnWidths.remarks }}>
      Remarks
      <div
        onMouseDown={(e) => startResize("remarks", e)}
        className="absolute top-0 right-0 h-full w-2 cursor-col-resize hover:bg-blue-400 opacity-40"
      />
    </th>

    <th className="p-1 sm:p-2 relative border-r border-[#b6c7d6]" style={{ width: columnWidths.valid_upto }}>
      Valid Upto
      <div
        onMouseDown={(e) => startResize("valid_upto", e)}
        className="absolute top-0 right-0 h-full w-2 cursor-col-resize hover:bg-blue-400 opacity-40"
      />
    </th>

  </tr>
</thead>
                <tbody>
                  {items.map((item, idx) => {
                    const isRowEditable =
                      item.status === "Open" || item.status === "Negotiation";
                    return (

                      <tr key={idx} className="border-t">
                        <td className="p-1 sm:p-2 text-center">{idx + 1}</td>
                        {["item_code", "description", "quantity", "unit_of_measure", "unit_price", "amount", "discount_percent", "discount", "net_amount", "status"].map((col, i) => (
                          <td key={i} className={`p-1 sm:p-2 ${col === "description" ? "whitespace-normal" : ""}`}>

                   <input
  name={col}
  type={col.includes("price") || col.includes("amount") || col.includes("discount") ? "number" : "text"}
  value={item[col]}

  onFocus={() => setActiveCell(`${idx}_${col}`)}
  onBlur={() => setActiveCell(null)}

  onChange={
    isRowEditable &&
    (col === "unit_price" || col === "discount_percent" || col === "quantity")
      ? e => handleItemChange(idx, e)
      : undefined
  }

  readOnly={
    !isRowEditable ||
    ["item_code","description","unit_of_measure","amount","discount","net_amount","status"].includes(col)
  }
style={{ width: columnWidths[col] }}
  className={`border rounded px-2 py-1 transition-all
  ${activeCell === `${idx}_${col}` ? "w-64 z-10 relative bg-white shadow-lg" : "w-16 sm:w-24"}
  ${col === "description" ? "min-w-[300px]" : ""}
  ${errors[`${col}_${idx}`] ? "border-red-400" : "border-[#c8d8e4]"}
  ${
    !isRowEditable ||
    ["item_code","description","unit_of_measure","amount","discount","net_amount","status"].includes(col)
      ? "bg-gray-100 cursor-not-allowed"
      : ""
  }`}
/>

                            {errors[`${col}_${idx}`] && <span className="text-xs text-red-500">*</span>}
                          </td>
                          
                        ))}
                 <td className="p-1 sm:p-2 min-w-[320px]" style={{ width: columnWidths.remarks }}>
  {item.remarks ? (
    <div className="relative border border-[#c8d8e4] rounded px-2 py-1 bg-gray-100">

      <div
        ref={(el) => {
          remarkRefs.current[idx] = el;
        }}
        className="text-sm text-gray-700 whitespace-normal break-words overflow-hidden pr-6"
        style={
          expandedRemarks[idx]
            ? {}
            : {
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical"
              }
        }
      >
        {item.remarks}
      </div>

      {/* Eye icon ONLY when text is actually truncated */}
      {remarkOverflow[idx] && (
        <button
          type="button"
          onClick={() => toggleRemark(idx)}
          className="absolute top-1 right-1 text-[#2b6777] hover:text-[#52ab98]"
          title={expandedRemarks[idx] ? "Collapse" : "Expand"}
        >
          {expandedRemarks[idx] ? <FaEyeSlash size={14} /> : <FaEye size={14} />}
        </button>
      )}
    </div>
  ) : (
    <div className="border border-[#c8d8e4] rounded px-2 py-1 bg-gray-100 text-gray-400 italic">
      —
    </div>
  )}
</td>
<td className="p-1 sm:p-2">
  <input
    type="date"
    value={item.valid_upto || ""}
    readOnly
    style={{ width: columnWidths.valid_upto }}
    className="border rounded px-2 py-1 w-32 border-[#c8d8e4] bg-gray-100 cursor-not-allowed"
  />
</td>



                      </tr>
                    )
                  },
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row justify-end gap-3 sm:gap-4 mt-4 sm:mt-6">
            <button
              type="button"
              className="px-4 py-2 rounded bg-gray-200 text-[#2b6777] font-semibold w-full sm:w-auto order-2 sm:order-1"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-6 py-2 rounded bg-[#52ab98] hover:bg-[#2b6777] text-white font-semibold shadow w-full sm:w-auto order-1 sm:order-2"
              disabled={loading || isSubmitting}
            >
              {loading || isSubmitting ? 'Saving...' : isEdit ? 'Update RFQ' : 'Save RFQ'}
            </button>
          </div>

        </form>
      </div>
    </div>
  );
};

export default RFQItemsFormModal;
